import React, { Component } from "react"
import Util from "../../Util"
import { TableLayout } from "../../components"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { ToastContainer, ToastMessage } from "react-toastr"
class TableGestoresTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreGestor(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }

  render() {
    var tableHeaders = ["CPF", "Nome", "Email", "Telefone", "Portaria", "Ações"]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />

        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar gestor de contrato"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">
                      {Util.getMaskedCPFCNPJ(row.cpf)}
                    </td>
                    <td className="col-md-3">{row.name}</td>
                    <td className="col-md-2">{row.email}</td>
                    <td className="col-md-2">
                      {Util.getMaskedPhone(row.telefone1)}
                    </td>
                    <td className="col-md-4">{row.portaria}</td>
                    <td className="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Restaurar gestor de contrato"
                        onClick={() => this.restore(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableGestoresTrash)



// WEBPACK FOOTER //
// ./src/views/gestores/TableGestoresTrash.js